// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBZ7HeJXpdwuYjHEMWBWEzhdx5OXOlZ0KY",
  authDomain: "onlineclasses-82b49.firebaseapp.com",
  projectId: "onlineclasses-82b49",
  storageBucket: "onlineclasses-82b49.firebasestorage.app",
  messagingSenderId: "997099700066",
  appId: "1:997099700066:web:27b5a86ea3e34933d6363b",
  measurementId: "G-YPE40EHV0H"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);